/* eslint-disable simple-import-sort/imports */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog } from '../../../../dialog/dialog';
import { LabelledContainer } from '../../../../labelled-container/labelled-container';
import { Select } from '../../../../select/select';
import { Stack } from '../../../../stack/stack';
import { Button } from '../../../../button/button';
import { ProjectGeodataManager } from '../../../../../../viewer/project-geodata-manager';
import { hasElements } from '../../../../../../utils/variables';

type Props = {
  onClose: (timeline?: { id: string }) => void;
};

const TimelineFilterDialog = (props: Props) => {
  const { t } = useTranslation('skyviewAssetMenu');
  const timelines = ProjectGeodataManager.instance().getDetailedTimelineItems();
  const [selectedId, setSelectedId] = React.useState<string | undefined>(
    hasElements(timelines) ? timelines[0]?.id : 'unset',
  );

  return (
    <Dialog closeIcon={true} closeOnDimmerClick={true} onClose={() => props.onClose()}>
      {{
        header: t('timeline.sectionName', { ns: 'skyviewAssetMenu' }),
        content: (
          <Stack spacing={1}>
            <LabelledContainer text={t('timeline.sectionName', { ns: 'skyviewAssetMenu' })}>
              <Select
                options={[
                  {
                    id: 'unset',
                    name: t('timeline.dropDown.unset', { ns: 'skyviewAssetMenu' }),
                  },
                  ...timelines.map((x) => ({ id: x.id, name: x.dateFormattedWithNumber })),
                ]}
                value={selectedId}
                onChange={(e) => setSelectedId(e.target.value)}
              />
            </LabelledContainer>
          </Stack>
        ),
        footer: {
          right: (
            <>
              <Button
                color="primary"
                variant="contained"
                onClick={() =>
                  props.onClose(
                    selectedId && selectedId !== 'unset' ? { id: selectedId } : { id: 'unset' },
                  )
                }
              >
                {t('confirm', { ns: 'common' })}
              </Button>
              <Button variant="text" onClick={() => props.onClose()}>
                {t('cancel', { ns: 'common' })}
              </Button>
            </>
          ),
        },
      }}
    </Dialog>
  );
};

export { TimelineFilterDialog };
